module.exports = __webpack_public_path__ + "nc_static/media/file-ppt.6b881d5d.svg";